import { ReactElement, cloneElement, useEffect, useState } from 'react';

// Define the props expected on the child Accordion component
interface AccordionChildProps {
  accordionKey: string;
  isOpen?: boolean;
  customClickHandler?: (accordionKey: string) => void;
}

// Create a more specific type for the child element
type AccordionElement = ReactElement<AccordionChildProps>;

interface Props {
  children: Array<AccordionElement | null | ''>;
  currentOpened?: string | null;
  customClickHandler?: (accordionKey: string) => void;
}

const AccordionGroup = ({ currentOpened, children, customClickHandler }: Props) => {
  const [internalActiveAccordion, setInternalActiveAccordion] = useState<string | null>(null);

  const setCurrentOpenAccordion = (accordionKey: string) => {
    if (customClickHandler) {
      customClickHandler(accordionKey);
    } else {
      setInternalActiveAccordion(accordionKey === internalActiveAccordion ? null : accordionKey);
    }
  };

  useEffect(() => {
    if (currentOpened !== undefined) setInternalActiveAccordion(currentOpened);
  }, [currentOpened]);

  return (
    <>
      {children?.map((child) => {
        if (!child) return null;
        return cloneElement(child, {
          customClickHandler: setCurrentOpenAccordion,
          isOpen: child.props.accordionKey === internalActiveAccordion,
        });
      })}
    </>
  );
};

export default AccordionGroup;
